import logo from "../assets/lynxtech-logo.jpeg";
import { COMPANY } from "../lib/site";

export default function Logo({ className = "", size = 44, showText = true, dark = false }) {
    return (
        <span className={`inline-flex items-center gap-3 ${className}`}>
            <img
                src={logo}
                alt="Lynxtech IT Solutions logo"
                width={size}
                height={size}
                style={{ width: size, height: size }}
                className="rounded-xl object-cover shadow-sm ring-1 ring-white/10"
            />
            {showText && (
                <span className="leading-tight">
                    <span
                        className={`block font-display text-[15px] font-bold tracking-tight ${
                            dark ? "text-white" : "text-navy"
                        }`}
                    >
                        Lynxtech
                    </span>
                    <span
                        className={`block font-mono text-[9px] uppercase tracking-[0.28em] ${
                            dark ? "text-sky-300" : "text-brand"
                        }`}
                    >
                        IT Solutions
                    </span>
                </span>
            )}
        </span>
    );
}
